<template>
    <div>
        <myHead/>
        <div>
            <div hoverable  class="queryDiv">
                <!-- <a-card style="border-radius:5px"> -->
                    <div style="float:left;line-height:40px">
                        <a-input :allowClear="true" v-model:value="queryModel.queryTxt" style="font-size:14px;width:270px"  placeholder="请输入任务编号/订单编号/买手账号" />
                        <a-select style="font-size:14px;margin-left:20px;width:150px" placeholder="请选择店铺" :allowClear="true" :filterOption="filterOption" show-search   v-model:value="queryModel.shopId">
                            <a-select-option v-for="v in shopList" :key="v.Name" :value="v.Id">{{v.Name}}</a-select-option>
                        </a-select>
                        <a-select style="font-size:14px;margin-left:20px;width:150px" placeholder="请选择订单状态"  :allowClear="true"    v-model:value="queryModel.status">
                            <a-select-option  :value="1">已完成</a-select-option>
                            <a-select-option  :value="3">进行中</a-select-option>
                            <a-select-option  :value="2">已退款</a-select-option>
                        </a-select>
                        <a-range-picker :placeholder="['开始日期', '结束日期']" style="font-size:14px;margin-left:20px"  v-model:value="queryModel.createTimes" />
                          <a-checkbox style="margin-left:20px" v-model:checked="queryModel.needPraise">需要好评</a-checkbox>

                    </div>
                    <div style="float:right">
                        <a-button style="display:inline-block;width:100px;margin-top:0px;margin-bottom:0px" @click="query"  class="otherBtn" >
                            搜索
                        </a-button>
                        <a-button style="display:inline-block;width:100px;margin-top:0px;margin-bottom:0px;margin-left:20px" @click="exportAction"  class="loginBtn"  >
                            导出结果
                        </a-button>
                    </div>
                <!-- </a-card> -->
            </div>
            <a-row  style="width:100%;padding-top:20px;padding-left:20px;padding-right:20px">
                <a-col flex="auto">
                    <a-table 
                        :rowKey="record => record.Id" 
                        :columns="columns"  
                        :loading="isLoading"
                        :data-source="recordList"
                        @change="handleTableChange"
                        :pagination="pagination">
                                    <template #img="{ text }">
                                        <a-image
                                             style="width:150px;height:150px"
                                            :src="text"
                                        />
                                    </template>
                                    <template #shopName="{ text,record }">
                                        <div style="height:46px">
                                            <div style="width:150px;line-height:46px;flot:left;vertical-align:middle; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                                    <svg style="vertical-align:middle"  width="40" height="40" v-if="record.ShopType==1" t="1624775837237"  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9375"><path d="M376.3 296.6c29.1-49.5 39.8-99 39.8-99l84.2 34-24.5 48s6.1 6.2 27.5 3.1 162.2-74.3 258.6-57.2c97.7 17.3 157.6 94.4 157.6 154.7v289.3s-10.7 88.2-85.7 119.1c-75 30.9-189.7 7.7-189.7 7.7l6.1-48s68.9 15.5 111.7 1.5c42.8-13.9 55.1-48 55.1-48v-345s-6.1-35.6-45.9-60.3c-39.8-24.8-59.7-21.7-102.5-15.5-42.8 6.2-108.6 37.1-108.6 37.1l-36.7 72.7h247.9v49.5H619.6v61.9h157.6v43.3l-154.5 6.2v117.6l73.5-32.5-6.1-51.1 59.7-12.4 44.4 117.6-73.5 34-9.2-41.8s-138.9 59.2-194.6 63.8c-55.7 4.6-110.4-8.8-137-46.9-26.5-38.1-20.3-114.4-20.3-114.4l99 2.5s-7.7 43.5 11.8 71S534 680 534 680V548.8l-153-4.6v-41.8h154.5l-1.5-61.9-47.4-9.3s-39.8 61.9-65.8 60.3c-26-1.5-29.1-37.1-29.1-37.1l84.2-105.2-45.9-4.6-68.9 82-52-46.4c-0.1-0.1 38.2-34.1 67.2-83.6z m-175.9 64.9l-52 74.3s111.7 55.7 120.9 100.6c9.2 44.9-153 179.5-153 179.5l115.7 85s119.8-212 110.7-281.6-142.3-157.8-142.3-157.8z m62.3-31.5c37.8 0 68.4-31 68.4-69.1 0-38.2-30.6-69.1-68.4-69.1-37.8 0-68.4 31-68.4 69.1 0 38.2 30.6 69.1 68.4 69.1z" fill="#d81e06" p-id="9376"></path></svg>
                                                    <svg style="vertical-align:middle"  width="40" height="40" v-else-if="record.ShopType==2" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8657"><path d="M178.9 377.2c1.6 21.1 4 42.4 4.8 63.6 1.5 39.5-14.1 70.9-46.2 93.9-24.7 17.7-51.8 30.6-81.4 37.6-34.6 8.1-63.4-20.3-54.4-54.7C6.8 498 13.4 478 23.6 460.7c25.4-42.8 41-89.2 53.7-136.8 2.3-8.9 5.5-17.7 9.5-26 6.9-14.4 22.6-21.8 37.7-17.3 10.9 3.3 21.5 7.9 31.6 13.3 16.1 8.4 31.8 18 47.6 27.1 9.7-10.4 19-21.4 29.1-31.4 35.4-35.1 79-57.4 123.5-78 69.7-32.2 141.4-59.5 216.8-75.2 34.9-7.2 70.6-11.9 106.2-14.6 42.5-3.2 85.2-4.8 127.7-3.7 55.2 1.3 109.6 8.6 160 34 27.2 13.7 50 32.6 54.9 63.6 3.4 21.7 2.1 44.7-0.4 66.8-4.1 37.5-19.4 72-34.3 106.1-4 9-14.4 16.2-23.3 21.5-22.8 13.3-48.2 20.2-74 25.1-72.7 13.9-144.1 7.7-213.6-17.3-41.3-14.8-74.6-41.8-104.9-72.7-3.2-3.2-5.7-7.5-9.6-9.3-4.1-2-10.6-3.6-13.5-1.6-3 2.1-4.8 9-4 13.1 1.1 4.9 4.8 9.8 8.4 13.7 44 47.6 97.6 79.5 160.7 94.1 75.4 17.4 150.5 16.5 224.5-8.1 4.2-1.4 8.4-3 12.5-4.9 4-1.8 7.9-4 13.4-4.9-8.2 11.9-15.9 24-24.4 35.6-57.4 77-131.1 131.2-224 158.3-59.3 17.3-118.6 14.8-177.6 0.5-98.5-24-189-65.4-267-131.4-24.3-20.5-47.2-42.7-63.2-70.6-6.2-10.7-11.4-22.4-14.4-34.2-2.3-9.7-6.2-15.8-14.3-18.3z m717.2-235.3c-11.4 1.1-23 1.5-34.3 3.3-17.5 2.8-34.2 8.5-48.1 20-12.3 10-10.9 24.5 2.8 32.2 5.5 3 11.7 5.3 17.7 6.9 27.7 7.6 55.9 5.6 83.9 2.5 14.4-1.6 28.6-6.2 42.1-11.4 9.3-3.6 16.3-11.6 15.9-23-0.5-10.9-9.3-14.8-17.3-18.6-19.7-9.2-41-11.8-62.7-11.9zM567.3 269.7c16.6 0 29.5-11.7 29.5-26.4-0.1-14.6-13.7-26.7-29.7-26.6-16.7 0.1-29.2 11.6-29.3 26.6 0 14.7 12.9 26.3 29.5 26.4z m128.5 635.9c-7.7 0-15.1 0.5-22.3-0.2-2-0.2-4.7-3.6-5.3-6.1-5.4-21-9.9-42.4-15.8-63.3-2.2-8.2-6.4-16.1-11.2-23.2-7.2-10.9-19.4-12.3-27.5-2.1-7.9 9.8-14.9 20.9-19.8 32.6-7.1 17-12.3 34.9-17.3 52.8-2.1 7.4-4.7 11.2-12.8 9.9-4.6-0.7-9.5-0.1-15.2-0.1 1.2-30.6 2.2-60.2 3.4-92.6-7.2 3.6-12.7 5.4-16.9 8.6-9.7 7.8-19.3 15.9-28 24.7-15.9 16.2-31.3 33-46.7 49.8-9.7 10.5-13.1 11.6-29.8 7.7 19.7-33.5 39.3-66.7 59.5-100.6-19.4-5.6-36.3-13.3-43.5-33.2-4.6-12.4-3.9-24.6 1.2-37.4 1.2 4.3 2.1 8.8 3.4 13.1 6.5 22.3 26.1 33.9 48.2 27.2 5.7-1.8 12-6.5 15.2-11.6 19.4-31.3 38.1-63 56.5-94.8 3.4-5.8 6.8-6.9 13.1-5.8 30.4 4.8 60.8 9.3 91.4 1.3 6.7-1.8 13.1-4.6 20.2-7.1v250.4z" p-id="8658" fill="#d81e06"></path></svg>
                                                    <svg style="vertical-align:middle"  width="40" height="40" v-else-if="record.ShopType==3" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8132"><path d="M204.8 81.2c10.3-9 21.4-17 33.2-24.1v343.3c-51.2-36.1-99.3-75.3-150.5-111.5-30.1-21.1-57.2-42.1-87.3-63.2C69.4 177.6 135.8 129.3 205 81.2h-0.2z m-69.2 81.3c0 9.1-3.1 15.1-3.1 24.1-3.1 9.1 9.1 21.1 0 30.1-6 15.1-12 27.1-18 39.2-3.3 4.5-3.3 10.6 0 15.1 3.1 6 12 3.1 18 3.1 6 3.1 9.1 6 15.1 6s9.1-3.1 15.1-3.1 12 3.1 15.1 0c3.1 0 6-3.1 12-6h15c6-3.1 6-12 3.1-18-9.7-9.7-17.8-20.9-24.1-33.2-9.1-12 6-27.1 0-39.2-3.1-3.1-3.1-12-3.1-18h-6c-2.5 7.8-7.9 14.3-15.1 18-7.8-2.5-14.3-7.9-18-15.1 0-3.1-3.1-3.1-6-3.1v0.1zM256 57.2c30.1 21.1 60.3 42.1 93.3 63.2l153.6 108.4c-5.6 3.2-10.7 7.3-15.1 12-75.3 51.2-150.5 105.5-228.9 156.7C256 286 256 171.6 256 57.2z m24.1 129.5c3.3 7.4 7.4 14.5 12 21.1 3.1 0 6-3.1 9.1-3.1V277c27 3 54.3 3 81.3 0 1.5-24.1 1.5-48.2 0-72.3 3.1 0 6 3.1 9.1 3.1 6.7-6.8 11.9-15 15.1-24.1-15.1-3.1-30.1-12-45.2-15.1-3.2 9-11.6 15-21.1 15.1-9.1 0-15.1-9.1-18-15.1-14.8 4.2-28.9 10.2-42.1 18l-0.2 0.1zM521 231.9c81.4-60.3 165.8-117.5 247-174.7v340.4C686.7 343.2 602.4 286 521.1 231.9h-0.1z m132.4-69.3c-4.5 14.7-4.5 30.5 0 45.2 6 15.1 21.1 24.1 30.1 36.1 6 6 3.1 15.1 3.1 21.1-8.6 2.8-16.7 6.8-24.1 12h54.3c-9.1-3.1-15.1-9.1-24.1-12 0-6-3.1-18 3.1-21.1 13.1-9.1 23.5-21.6 30.1-36.1 6-15.1 0-30.1-3.1-45.2h-69.4zM783.1 57.2l63.2 45.2c51.2 36.1 99.3 69.2 150.5 105.5l27.1 18C942.6 283.1 864.3 340.3 783 400.6V57.2z m45.2 93.3c2.6 11.1 10.5 20.1 21.1 24.1h18c-3.1-6-3.1-15.1-9.1-18-9-9.2-21.1-6.1-30-6.1z m48.1 9.1c-3.7 4.6-6.7 9.7-9.1 15.1 6 0 15.1 0 18-3.1 3.7-4.6 6.8-9.7 9.1-15.1-6.1-0.5-12.3 0.6-18 3.1z m-18 21.1c-27.9 4.5-46.9 30.8-42.4 58.7 0.1 0.5 0.2 1.1 0.3 1.6 4.1 26.1 27.8 44.5 54.1 42.1 13.8-1.6 26.5-8 36.1-18 11.9-15.4 15.3-35.8 9.1-54.3-11-21-33.8-33-57.2-30.1z m-66.3 234.9c78.3-57.2 153.6-111.5 231.9-168.7v340.4C945.7 530 870.4 475.7 792.1 418.5c0 0-3.1-3.1 0-3.1v0.2z m123.5-33.2c-19.8 2.5-36.8 15.1-45.2 33.2-3.1 12 9.1 18 15.1 27.1 9.4 8 20.9 13.2 33.2 15.1 8.6 6.7 17.6 12.7 27.1 18 2.5-7.8 3.5-15.9 3.1-24.1 10.5-6.3 20.6-13.4 30.1-21.1 9.1 3.1 15.1 12 21.1 15.1 3.1 0 9.1 0 9.1-3.1-0.6-7.4-2.6-14.5-6-21.1 3.8-6.4 5.8-13.7 6-21.1 0-6-6-9.1-12-6-6.4 3.4-11.7 8.7-15.1 15.1-12-6-21.1-15.1-33.2-21.1v-24.1c-15.1 0-24.1 12-33.2 18l-0.1 0.1zM0 249.9c78.3 57.2 153.6 111.5 231.9 168.7 3.1 0 0 3.1 0 3.1C153.6 475.8 78.3 533.1 0 587.2V249.9z m69.2 117.5c-2.3 5.4-5.4 10.5-9.1 15.1-2.9 3.7-7.3 5.9-12 6-8.1 6.6-12.6 16.6-12 27-3 9.8-3 20.3 0 30.1 0.9 9.1 8.9 15.8 18 15.1h69.2c5.6-0.1 11-2.2 15.1-6 6-6 3.1-18 3.1-27.1-1.2-12.4-4.3-24.6-9.1-36.1-6.2-3.7-12.3-7.7-18-12-2.8-10.3-10.8-18.4-21.1-21.1-8.8 0.2-17.2 3.4-24.1 9z m349.4-21.1c12-15.1 15.1-33.2 24.1-48.1 8.3 14.5 15.3 29.6 21.1 45.2 6 0 12 3.1 21.1 3.1v17.9c9.1-3.1 18-3.1 30.1-6-6-21.1-15.1-42.1-21.1-60.3 21.1 9.1 39.2 15.1 57.2 24.1-6 12-9.1 27.1-15.1 42.1 9.1-3.1 18-3.1 24.1-6 3.1 0 3.1-3.1 6-6 8.3-17.6 15.4-35.7 21.1-54.3 15.1 9.1 27.1 21.1 42.1 30.1l-9.1 9.1c-9.1 9.1-21.1 15.1-30.1 24.1h39.2c3.1 9.1 6 21.1 9.1 30.1h-23.9c-3.1 12-6 24.1-9.1 39.2 11.4 1.6 22.5 4.7 33.2 9.1 5.8 9.2 9.9 19.4 12 30.1-12 3.1-27.1 3.1-39.2 6l-9.1 63.2c-6.3 6-13.4 11.1-21.1 15.1-6-27.1-9.1-54.3-15.1-81.3-9.2 0.5-18.3-0.6-27.1-3.1-6 21.1-9.1 45.2-15.1 66.3-6 9.1-15.1 9.1-24.1 15.1 0.5-26.1-0.5-52.3-3.1-78.3-6.2 0.4-12.4-0.6-18-3.1-3.1-9.1-6-15.1-9.1-24.1-12 12-9.1 30.1-12 45.2-3.1 21.1-6 42.1-9.1 60.3-16.8-11.1-32.8-23.1-48.1-36.1 9.1-3.1 21.1-6 30.1-9.1-3.1-15.1-3.1-30.1-6-45.2-6 3.1-12 9.1-18 12-6-15.1-9.1-33.2-15.1-48.1 11.3-0.3 22.5-2.3 33.2-6 0-12-3.1-21.1-3.1-33.2-3.1 0-6-3.1-9.1-3.1-6.7-9.6-12.7-19.7-18-30.1 8.4-0.2 16.6-2.3 24.1-6l0.1 0.1z m39.1 75.3h30.1l-9.1 18 27.1-9.1c-3.1-9.1-3.1-21.1-6-30.1-6-3.1-12-3.1-18-6-6-6-6-12-9.1-18-12 9.1-12 27.1-15.1 45.2h0.1z m87.3-24.1c-3.1 12-3.1 24.1-6 36.1 12-3.1 21.1-3.1 33.2-6 0-12-3.1-24.1-3.1-33.2-8.2-0.4-16.3 0.6-24.1 3.1zM84.2 367.4c9.1-3.1 18 6 21.1 15.1H69.2c6-6 9.1-12 15.1-15.1h-0.1z m448.9 240.9L768 436.7V780l-72.3-54.3c-54.3-39.2-108.4-81.3-162.7-117.5l0.1 0.1z m141.6-69.2c-3.1 6-3.1 15.1-6 21.1 6-3.1 12-3.1 18-6 10.4-2.4 21.4-0.2 30.1 6-3.1-6-3.1-15.1-6-21.1h-36.1z m6 27.1c-12.2 3.6-22.1 12.4-27.1 24.1-4.8 17.4 2.6 35.9 18 45.2 14.7 8.6 33.3 6.1 45.2-6 15.1-12.7 17.1-35.2 4.4-50.3-3.6-4.4-8.3-7.8-13.5-10-9.1-6-18-3.1-27.1-3.1l0.1 0.1z m-12 78.3c3.1 6 3.1 15.1 6 21.1h33.2c2.4-6.9 4.4-14 6-21.1-12.1 9.1-30.1 6.1-45.2 0z m114.4-210.8c81.3 57.1 159.6 111.4 240.9 168.6l-126.5 90.4C861.4 719.8 822.2 747 786 774c-3-111.5-3-226-3-340.4l0.1 0.1z m78.3 96.4v24.1h9c3.1-6 0-9.1 0-15.1 6-9.1-6-6-9.1-9.1l0.1 0.1z m-33.1 3.1v21.1c3.1 0 6 3.1 9.1 3.1-3.1-9.1 6-24.1-9.1-24.1v-0.1z m69.2 0c-3.1 6 0 12 0 18 0 3.1 9.1 3.1 9.1 0 3.1-6 0-12 0-18h-9.1z m-78.3 32.9v87.3c0 3.1 6 6 9.1 6h69.2c6 0 12 3.1 15.1-3.1 2.5-5.7 3.5-11.9 3.1-18 6-3.1 9.1-3.1 15.1-6 9.5-6.9 12.1-20 6-30.1-6-7.7-14.5-13.1-24.1-15.1v-21h-93.5zM0 602.3C78.3 548 156.7 490.8 238 436.7V777c-48.1-33.2-93.3-69.2-141.6-105.5-33.2-24-66.3-45.1-96.4-69.2z m198.8-57.2c-6 9.1-15.1 15.1-18 24.1-9.1 15.1-12 33.2-24.1 48.1-18 6-42.1 6-57.2 24.1 17.6 12.2 39.9 15.5 60.3 9.1 12-3.1 15.1-15.1 18-24.1 1.3-11.5 6.6-22.2 15.1-30.1 3.1-3.1 6 3.1 6 6v51.2h5.9c0-18-3.1-39.2 6-57.2 5.1-9.1 7.2-19.7 6-30.1-3.4-8.9-9.8-16.3-18-21.1zM256 436.7c48.1 33.2 93.3 66.3 138.5 102.4 30.1 24.1 63.2 45.2 93.3 69.2C409.6 665.5 331.3 722.8 256 780V436.7z m66.3 111.5c-6 3.1-6 9.1-12 12-8.1-0.5-16.3 0.6-24.1 3.1-3.1 0-6 6-6 9.1v69.2c0 6 9.1 6 12 6h99.3c6 0 6-6 6-12v-69.5c-8.2-4.8-17.7-6.9-27.1-6-3.6-5.6-8.9-9.8-15.1-12l-33 0.1zM265.1 792c81.3-57.2 159.6-114.4 240.9-168.7V804c3.1 54.3 0 108.4 0 159.6-57.2-39.2-111.5-81.3-168.7-120.4-24.1-18-51.2-36.1-72.3-51.2h0.1z m150.5-66.3h12c-3.1-3.1-3.1-6-6-6l-6 6z m-42.1 27.1c-7.8 11.1-13.9 23.2-18 36.1 3.1 0 9.1-3.1 12-3.1 9.1 0 18 3.1 24.1 0 6.7-3 14.4-3 21.1 0 0.5 16.2-0.5 32.4-3.1 48.4 0 6-9.1 6-12 6l-9.1-18c-3.1 3.1-6 3.1-6 6-1.3 10.6 5 20.6 15.1 24.1 11.3 3.5 23.4-2.9 26.9-14.2l0.3-0.9V786c9.1-2 18.7-0.9 27.1 3.1 10.8-3 22.3-3 33.2 0-1.9-12.2-7.1-23.7-15.1-33.2-5.7-6.7-13-11.9-21.1-15.1-24.2-17.5-57.9-12.1-75.4 12z m147.6-129.4c81.3 57.2 159.6 111.5 240.9 168.7-78.3 57.2-159.6 117.5-238 174.7-3-117.5-3-231.9-3-343.2l0.1-0.2z m78.3 96.4c-3.1 3.1-3.1 9.1-9.1 9.1-9.1 6-18 15.1-27.1 21.1 3.5 2.4 7.8 3.5 12 3.1h66.3c-6-9.1-15.1-12-21.1-18-9.1-6-15.1-12-21.1-15.1l0.1-0.2z m-36.2 45.1v63.2c0 3.1 0 9.1 6 9.1h69.2c2.5-8.8 3.5-18 3.1-27.1v-45.2c0-3.1-6-3.1-9.1-3.1-23.1-0.6-46.2 0.4-69.2 3.1z" p-id="8133" fill="#d81e06"></path></svg>
                                                    <svg style="vertical-align:middle"  width="40" height="40" v-else-if="record.ShopType==5" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7433" ><path d="M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2 0.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-0.5 0.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9z m85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-0.1-6.8-1.4-13.3-4.1-19.1z" p-id="7434" fill="#d81e06"></path></svg>
                                                    <svg style="vertical-align:middle"  width="40" height="40" v-else class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1814" ><path d="M937.4 423.9c-84 0-165.7-27.3-232.9-77.8v352.3c0 179.9-138.6 325.6-309.6 325.6S85.3 878.3 85.3 698.4c0-179.9 138.6-325.6 309.6-325.6 17.1 0 33.7 1.5 49.9 4.3v186.6c-15.5-6.1-32-9.2-48.6-9.2-76.3 0-138.2 65-138.2 145.3 0 80.2 61.9 145.3 138.2 145.3 76.2 0 138.1-65.1 138.1-145.3V0H707c0 134.5 103.7 243.5 231.6 243.5v180.3l-1.2 0.1" p-id="1815" fill="#d81e06"></path></svg>
                                                 <span style="vertical-align:middle;margin-left:5px">{{text}}</span>
                                            </div>
                                        </div>
                                    </template>

                                    <template #advanceMoneyText="{ text }">
                                        <span style="font-weight:500">
                                            {{text}}
                                        </span>
                                    </template>
                                    <template #principalText="{ text }">
                                        <span style="font-weight:500">
                                            {{text}}
                                        </span>
                                    </template>
                                    <template #actualCommissionText="{ text }">
                                        <span style="font-weight:500">
                                            {{text}}
                                        </span>
                                    </template>
                                    <template #orderCode="{ text }">
                                        <span style="font-weight:500">
                                            {{text}}
                                        </span>
                                    </template>
                                    <template #code="{ text }">
                                        <a>
                                            {{text}}
                                        </a>
                                    </template>
                                    <template #orderTitle="{ text,record }">
                                        <a-tooltip placement="bottom">
                                            <template #title>
                                            <span>{{text}}</span>
                                            </template>
                                            <div style="width:150px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                                <a target="_blank" :href="record.Url" >{{text}}</a>
                                            </div>
                                        </a-tooltip>
                                    </template>
                                    <template #status="{ text,record }">
                                            <a-tag v-if="record.IsRefund" color="#F56C6C">已退款</a-tag>
                                            <a-tag v-else-if="text==11" color="#67C23A">已完成</a-tag>
                                            <a-tag v-else color="#409EFF">进行中</a-tag>
                                    </template>
                                    <template #praiseStatus="{ text,record }"> 
                                            <a-tag style="cursor: pointer;" @click="setPraise(record)" v-if="text==0" color="blue">追加好评</a-tag>
                                            <a-tag style="cursor: pointer;" @click="setPraise(record)"  v-else-if="text==1" color="red">待好评</a-tag>
                                            <a-tag style="cursor: pointer;" @click="setPraise(record)"  v-else color="green">已好评</a-tag>
                                    </template>
                    </a-table>
                </a-col>
            </a-row>
        </div>
           <myFooter/>


               <a-drawer
    title="设置订单好评"
    :width="800"
    :visible="praiseVisible"
    :body-style="{ paddingBottom: '80px' }"
    @close="praiseVisible=false"
  >
    <a-form :model="setRow"     layout="vertical">
        <a-row :gutter="16">
            <a-col :span="24">
                <a-form-item label="好评文字">
                     <a-textarea :readonly="setRow.PraiseStatus>0" v-model:value="setRow.PositiveContent" placeholder="请输入好评内容" showCount   />
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16" style="height:148px">
            <a-col :span="24">
                <a-form-item label="好评图片">
                    <a-upload
                     accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                    :multiple="true"
                    :action="baseUrl+'/Task/PushImg'"
                    list-type="picture-card"
                    v-model:file-list="fileList"
                    @preview="handlePreview"
                    >
                    <div v-if="setRow.PraiseStatus==0">
                        <PlusOutlined />
                    </div>
                    </a-upload>
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16">
            <a-col :span="24">
                <a-form-item label="好评视频">
                        <a-upload
                        
                             name="file"
                            accept=".mp4"
                            :multiple="false"
                            :action="baseUrl+'/Task/PushVideo'"
                            @change="handleChange"
                         >
                            <a-button v-if="!setRow.Video"  :loading="uploading">
                               点击上传
                            </a-button>
                            
                        </a-upload>
                         <video id="video1" style="width:100%;height:240px;margin-top:15px" :src="setRow.Video" controls>
                            您的浏览器不支持 video 标签。
                        </video>
                </a-form-item>
            </a-col>
        </a-row>
        <a-row v-if="setRow.PraiseStatus==3">
            <a-form-item label="买手上传截图">
            <template v-if="setRow.NewPraiseImg.length==0">
                <a-image :width="104"  :src="setRow.OldPraiseImg"/>
            </template>
            <template v-else>
                <a-image v-for="(v,i) in setRow.NewPraiseImg" :key="i" :width="104"  :src="v"/>
            </template>
            </a-form-item>
        </a-row>
        <a-row>
            <a-form-item style="margin:auto">
                
                <a-alert
                    message="费用说明"
                    description="纯文字好评 2元/单、带图片 3元/单、带视频 5元/单，评价完成之后，系统将自动从余额扣除！"
                    type="info"
                    show-icon/>
            </a-form-item>
        </a-row>
    </a-form>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">

      <a-button style="margin-right: 8px" @click="praiseVisible=false">取消</a-button>
      <a-button type="primary" :disabled="setRow.PraiseStatus>0" @click="praiseSumbit">确定</a-button>
    </div>
  </a-drawer>
                    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible=false">
                        <img alt="example" style="width: 100%" :src="previewImage" />
                    </a-modal>
    </div>
</template>
<script>
import { PlusOutlined} from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
 
 
import myHead from '../components/myHead'
import myFooter from '../components/myFooter'
//  import myPreview from '../components/myPreview'

import {  taskGetOrder,shopGetSel,uri,orderSetPraise,memberGet } from '@/request.js'

export default {
    
    components:{myHead,myFooter,PlusOutlined},
    data() {
        return {
            baseUrl:uri,
            previewImage:"",
            fileList:[],
            previewVisible:false,
            uploading:false,
            praiseVisible:false,
            shopList:[],
            queryModel:{
                queryTxt:"",
                createTimes:undefined,
                shopId:undefined,
                type:undefined,
                needPraise:false,
            },
            recordList:[],
            isLoading:false,
            pagination: {
                total: 0,
                pageSize: 8,//每页中显示10条数据
                showSizeChanger: true,
                pageSizeOptions: ["8", "16", "32", "64"],//每页中显示的数据
                showTotal: total => `共 ${total} 条`,  //分页中显示总的数据
                onShowSizeChange: (current, pageSize) => {
                    this.pagination.current = 1;
                    this.pagination.pageSize = pageSize;
                    this.orderGetAction(1); //显示列表的接口名称
                },
            },
            columns:[
            {
                    title: '主图',
                    dataIndex: 'Img',
                    key: 'Img',
                    slots: { customRender: 'img' },
                },
                {
                    title: '所属任务',
                    dataIndex: 'Code',
                    key: 'Code',
                    slots: { customRender: 'code' },
                },
                {
                    title: '店铺名称',
                    dataIndex: 'ShopName',
                    key: 'ShopName',
                    slots: { customRender: 'shopName' },
                },
                {
                    title: '商品名',
                    dataIndex: 'Title',
                    key: 'Title',
                    slots: { customRender: 'orderTitle' },
                },
                // {
                //     title:"进店方式",
                //     key: 'KeyWords',
                //      slots: { customRender: 'keyWords' },
                // },
                {
                    title: '买手提交单号',
                    dataIndex: 'OrderCode',
                    key: 'OrderCode',
                    slots: { customRender: 'orderCode' },
                },
                {
                    title: '买手账号',
                    dataIndex: 'AliTrademanager',
                    key: 'AliTrademanager',
                },
                {
                    title: '预计本金',
                    dataIndex: 'PrincipalText',
                    key: 'PrincipalText',
                    slots: { customRender: 'principalText' },
                },
                {
                    title: '实际本金',
                    dataIndex: 'AdvanceMoneyText',
                    key: 'AdvanceMoneyText',
                    slots: { customRender: 'advanceMoneyText' },
                },
                {
                    title: '佣金',
                    dataIndex: 'ActualCommissionText',
                    key: 'ActualCommissionText',
                    slots: { customRender: 'actualCommissionText' },
                },
                {
                    title: '接单时间',
                    dataIndex: 'OrderTime',
                    key: 'OrderTime',
                },
                {
                    title: '状态',
                    dataIndex: 'Status',
                    key: 'Status',
                    slots: { customRender: 'status' },
                },
                {
                    title: '好评',
                    dataIndex: 'PraiseStatus',
                    key: 'PraiseStatus',
                    slots: { customRender: 'praiseStatus' },
                },
            ],
            setRow:{},
            member:{},
        };
    },
    methods: {
        handleChange(info){
            if(info.file.status=="uploading"){
                this.uploading=true;
            }
            else if(info.file.status=="removed"){
                this.setRow.Video="";
            }
            else{
                if(info.file.response){
                    var res=info.file.response;
                    if(res.IsSuccess){
                        this.uploading=false;
                        this.setRow.Video= res.Message;
                    }else{
                        message.error(res.Message);
                    }
                }
            }
        },
        handlePreview(file){
            this.previewImage = file.response.Message;
            this.previewVisible = true;
        },
        preview(url){
            this.previewImage = url;
            this.previewVisible = true;
        },
        praiseSumbit(){
            if(!this.setRow.PositiveContent&&!this.setRow.Video&&this.fileList.length==0){
                message.warning('请至少上传一项好评内容');
                return;
            }
            let array=[];
            this.fileList.forEach(x=>{
                array.push(x.response.Message);
            })
            this.setRow.ResourcesImg=JSON.stringify(array);
            orderSetPraise({
               Id:this.setRow.Id,
               ResourcesImg:this.setRow.ResourcesImg,
               Video:this.setRow.Video,
               PositiveContent:this.setRow.PositiveContent
           },(res)=>{
                if(res.IsSuccess){
                    this.setRow.PraiseStatus=1;
                    this.praiseVisible=false;
                }else{
                    message.error(res.Message);
                }
                
           })
        },
        setPraise(record){
            var array=new Array();
            record.ResourcesImgList.forEach(x=>{
                 array.push({
                    name:x,
                    response:{
                        IsSuccess:true,
                        Message:x,
                    },
                    status:"done",
                    thumbUrl:x,
                    type:"image/jpeg",
                    uid:x.Img,
                });
            })
            this.fileList=array;
            this.setRow=record;
            this.praiseVisible=true;
        },
        query(){
            this.pagination.current = 1;
            this.orderGetAction(1);
        },
        exportAction(){

            let json=sessionStorage.getItem("member");
            if(json==null||json=="null"){
                memberGet({},(res)=>{
                    this.member=res.Result;
                    sessionStorage.setItem("member",JSON.stringify(res.Result));
                })
            }else{
                this.member=JSON.parse(json);
            }
            let array=new Array();
            if(this.queryModel.createTimes!==undefined&&this.queryModel.createTimes.length>0){
                for(var i=0;i<this.queryModel.createTimes.length;i++){
                    array.push(this.format(new Date(this.queryModel.createTimes[i]),"yyyy-MM-dd 00:00:00"))
                }
            }

              window.open(uri+"/Task/GetExl?queryTxt="+this.queryModel.queryTxt+"&status="+(this.queryModel.status==undefined?0:parseInt(this.queryModel.status))
           +"&shopId="+(this.queryModel.shopId==undefined?0:parseInt(this.queryModel.shopId))+"&createTimes="+(array.length==0?"[]":JSON.stringify(array))
           +"&memberId="+this.member.Id+"&needPraise="+this.queryModel.needPraise);
        },
        orderGetAction(pageIndex){
            let array=new Array();
            if(this.queryModel.createTimes!==undefined&&this.queryModel.createTimes.length>0){
                for(var i=0;i<this.queryModel.createTimes.length;i++){
                    array.push(this.format(new Date(this.queryModel.createTimes[i]),"yyyy-MM-dd 00:00:00"))
                }
            }

            this.isLoading=true;
            taskGetOrder({
                pIndex:pageIndex,
                pSize:this.pagination.pageSize,
                queryTxt:this.queryModel.queryTxt,
                shopId:this.queryModel.shopId==undefined?0:this.queryModel.shopId,
                status:this.queryModel.status==undefined?0:this.queryModel.status,
                needPraise:this.queryModel.needPraise==undefined?0:this.queryModel.needPraise,
                createTimes:array.length==0?"[]":JSON.stringify(array),
                rebateMethod:0
            },(res)=>{
                this.recordList=res.Result;
                this.pagination.total=res.TotalCount;
                this.pagination.current = res.PageIndex;
                this.isLoading=false;
            })
        },
        to(path){
            this.$router.push(path)
        },
        filterOption(input, option) {
            return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        handleTableChange(e){
             this.orderGetAction(e.current);
        },
        format (date,fmt) {
            let o = {
                "M+": date.getMonth() + 1,         //月份
                "d+": date.getDate(),          //日
                "h+": date.getHours(),          //小时
                "m+": date.getMinutes(),         //分
                "s+": date.getSeconds(),         //秒
                "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                "S": date.getMilliseconds()       //毫秒
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            }
            for (let k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                }
            }
            return fmt;
        }
    },
    created(){
    },
    mounted() {
        if(this.$route.query.code){
            this.queryModel.queryTxt=this.$route.query.code;
        }
        this.orderGetAction(1);
        shopGetSel({},(res)=>{
            this.shopList=res.Result;
        })
    }
};
</script>
<style scoped>

.queryDiv{
    
    margin-top:20px;
    margin-bottom:20px;
    margin-right:20px;
    margin-left:20px
}
.queryTxt{
    font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #0d0c22;
}
</style>